import React, { useState, useEffect } from 'react';
import { collection, addDoc, getDocs, query, orderBy } from 'firebase/firestore';
import { db } from '../../firebase/config';
import ReactStars from 'react-rating-stars-component';

export const Reviews = () => {
  const [reviews, setReviews] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [newReview, setNewReview] = useState({
    name: '',
    content: '',
    rating: 5,
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const fetchReviews = async () => {
    const reviewsQuery = query(collection(db, 'reviews'), orderBy('timestamp', 'desc'));
    const snapshot = await getDocs(reviewsQuery);
    const reviewsData = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
    setReviews(reviewsData);
  };

  useEffect(() => {
    fetchReviews();
  }, []);


  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!newReview.name || !newReview.content) return;

    setIsSubmitting(true);
    try {
      await addDoc(collection(db, 'reviews'), {
        name: newReview.name,
        content: newReview.content,
        rating: newReview.rating,
        timestamp: new Date().toISOString()
      });
      setNewReview({
        name: '',
        content: '',
        rating: 5,
      });
      setIsModalOpen(false);
      fetchReviews();
    } catch (error) {
      console.error('Error adding review:', error);
    }
    setIsSubmitting(false);
  };

  return (
    <div className="px-8 lg:px-24 mt-8 pb-12">
      <div className="text-center font-bold text-2xl mb-6">ביקורות</div>
      
      {/* Add Review Button */}
      <div className="text-center mb-8">
        <button
          onClick={() => setIsModalOpen(true)}
          className="bg-cBrownDark text-cWhite font-bold py-3 px-6 rounded-lg hover:bg-opacity-90 transition-all"
        >
          הוסף ביקורת
        </button>
      </div>

      {/* Reviews Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {reviews.map((review) => (
          <div key={review.id} className="bg-white rounded-xl shadow-lg p-6 transition-transform hover:scale-105">
            <div className="flex items-center mb-4">
              <div className="flex-grow">
                <div className="font-bold text-right text-lg">{review.name}</div>
                <ReactStars
                  count={5}
                  value={review.rating}
                  size={20}
                  edit={false}
                  activeColor="#ffd700"
                />
              </div>
            </div>
            <div className="text-right text-gray-600">{review.content}</div>
          </div>
        ))}
      </div>

      {/* Review Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center z-50">
          {/* Modal Overlay */}
          <div 
            className="absolute inset-0 bg-black opacity-50"
            onClick={() => setIsModalOpen(false)}
          ></div>
          
          {/* Modal Content */}
          <div className="relative bg-white rounded-xl p-8 max-w-md w-full mx-4 shadow-2xl">
            <div className="flex justify-between items-center mb-6">
              <div></div>
              <h3 className="text-xl font-bold">כתוב ביקורת</h3>
              <button 
                onClick={() => setIsModalOpen(false)}
                className="text-gray-500 hover:text-gray-700 text-xl font-bold"
                >
                ✕
                  </button>
            </div>

            <form onSubmit={handleSubmit} className="space-y-4">
            
              <div className="flex justify-center">
                <ReactStars
                  count={5}
                  value={newReview.rating}
                  onChange={(rating) => setNewReview(prev => ({ ...prev, rating }))}
                  size={30}
                  activeColor="#ffd700"
                />
              </div>

              <input
                type="text"
                value={newReview.name}
                onChange={(e) => setNewReview(prev => ({ ...prev, name: e.target.value }))}
                placeholder="השם שלך"
                className="w-full p-3 border rounded-lg text-right focus:outline-none focus:ring-2 focus:ring-cBrownDark focus:border-transparent"
                required
              />

              <textarea
                value={newReview.content}
                onChange={(e) => setNewReview(prev => ({ ...prev, content: e.target.value }))}
                placeholder="כתוב את הביקורת שלך כאן"
                className="w-full p-3 border rounded-lg text-right h-32 focus:outline-none focus:ring-2 focus:ring-cBrownDark focus:border-transparent"
                required
              />

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-cBrownDark text-white font-bold py-3 px-4 rounded-lg hover:bg-opacity-90 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isSubmitting ? 'שולח...' : 'שלח ביקורת'}
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}; 